<template>
	<div class="watch-readings">
		<router-view class="menu" name="menu"/>
		<router-view class="body"/>
	</div>
</template>

<script>
export default {
	props: [
		'user_uid',
		'watch_id',
		'profile'
	]
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/Readings.vue